'use client';

import type { DrawNumber } from '../../../../../schema/draw/entry.js';
import type { Definition } from '../../../../../schema/frameworks/entry.js';
import { getInstanceClient } from '../../../../di/entry.browser.js';
import type { ActionResult } from '../../../../lib/entry.js';

type MarketplaceBalanceReturnType = Awaited<
  ReturnType<ReturnType<typeof getInstanceClient<'IGetMarketplaceBalanceController'>>>
>;

type GetMarketplaceBalanceParams = {
  product: Definition['drawProducts'][number];
  drawNumber: DrawNumber;
};

/**
 * Function to get marketplace balance.
 *
 * @param root0 - The parameters for getting marketplace balance
 * @param root0.product - The product for which to get the marketplace balance
 * @param root0.drawNumber - The draw number for which to get the marketplace balance
 * @returns The marketplace balance info
 */
export async function getMarketplaceBalance({
  product,
  drawNumber,
}: GetMarketplaceBalanceParams): Promise<ActionResult<MarketplaceBalanceReturnType>> {
  const getMarketplaceBalanceController = getInstanceClient('IGetMarketplaceBalanceController');

  try {
    const response = await getMarketplaceBalanceController({ product, drawNumber });
    return { status: 'SUCCESS', data: response };
  } catch {
    return { status: 'ERROR', error: 'Det gick inte att hämta saldo för tillfället' };
  }
}
